var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Watch, Prop, Emit } from "vue-property-decorator";
import { CaseMarkColor } from "~/config/enum.config";
var DataBox = /** @class */ (function (_super) {
    __extends(DataBox, _super);
    function DataBox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rowIndex = -1;
        return _this;
    }
    /**
     *  清除选择项
     */
    DataBox.prototype.clearSelection = function () {
        this.table.clearSelection();
        this.table.setCurrentRow();
    };
    DataBox.prototype.onRowClick = function (row, event, column) { };
    // 分页信息改变消息
    DataBox.prototype.pageConfigChange = function (page) {
        return page;
    };
    // 更新选择项列表
    DataBox.prototype.updateSelectionList = function (list) {
        return list;
    };
    // 更新当前选择项
    DataBox.prototype.updateSelectionRow = function (row) { };
    // 监听当前选中行变化
    DataBox.prototype.onSelectionRowChange = function (val, oldVal) {
        var _this = this;
        this.$nextTick(function () {
            _this.table.setCurrentRow(val);
        });
    };
    // 监听当前选中列表变化
    DataBox.prototype.onSelectionListChanged = function (val, oldVal) {
        var _this = this;
        if (!val) {
            return;
        }
        //  等待data 渲染完毕之后再进行选中行赋值
        this.$nextTick(function () {
            _this.data.forEach(function (row) {
                var checkFlag = _this.selectionList.includes(row);
                _this.table.toggleRowSelection(row, checkFlag);
            });
        });
    };
    DataBox.prototype.tableHeight = function () {
        if (this.height === "") {
            return this.maxHeight;
        }
        else {
            return this.height;
        }
    };
    Object.defineProperty(DataBox.prototype, "showTopSlot", {
        get: function () {
            return this.$slots.buttons || this.$slots.append;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataBox.prototype, "emptyText", {
        get: function () {
            return this.data ? "暂无数据" : " ";
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 组件初始化
     */
    DataBox.prototype.mounted = function () {
        this.table = this.$refs["table"];
    };
    /**
     * 监听绑定数据变化
     */
    DataBox.prototype.onDataChanged = function (newVal, oldVal) { };
    /**
     * 页码数量变化回调
     */
    DataBox.prototype.pageSizeChange = function (value) {
        this.page.pageIndex = 1;
        this.page.pageSize = value;
        this.pageConfigChange(this.page);
    };
    /**
     * 页码位置变化回调
     */
    DataBox.prototype.pageIndexChange = function (value) {
        this.page.pageIndex = value;
        this.pageConfigChange(this.page);
    };
    /**
     * 排序改变
     */
    DataBox.prototype.onSortChange = function (_a) {
        var column = _a.column, prop = _a.prop, order = _a.order;
        if (this.sort) {
            this.sort.update(prop, order);
            this.pageConfigChange(this.page);
        }
    };
    DataBox.prototype.rowStyle = function (_a) {
        var row = _a.row, rowIndex = _a.rowIndex;
        if (!this.showCaseMark)
            return;
        if (!row.caseMark)
            return;
        var color = CaseMarkColor.find(function (x) { return x.value === row.caseMark; });
        if (color) {
            return {
                backgroundColor: color.color
            };
        }
    };
    DataBox.prototype.spanMethod = function (_a) {
        var row = _a.row, column = _a.column, rowIndex = _a.rowIndex, columnIndex = _a.columnIndex;
        if (!this.rowSpanKey)
            return;
        var columnProperty = this.rowSpanKey;
        if (column.property !== columnProperty)
            return;
        // 当前单元格的值
        var currentValue = row[columnProperty];
        var span = {
            rowspan: 0,
            colspan: 0
        };
        var beforRow = rowIndex > 0 ? this.data[rowIndex - 1] : null;
        if (beforRow && beforRow[columnProperty] === currentValue)
            return span;
        // 如果当前单元格的值与上一行的对应单元格的值一致，则合并行已经计算过
        span.colspan = 1;
        span.rowspan = 1;
        var nextRowIndex = rowIndex + 1;
        while (nextRowIndex < this.data.length) {
            // 如果下一行对应单元格的值与当前单元格的值一致
            var nextRowValue = this.data[nextRowIndex][columnProperty];
            if (nextRowValue === currentValue)
                span.rowspan += 1;
            nextRowIndex += 1;
        }
        return span;
    };
    __decorate([
        Prop()
    ], DataBox.prototype, "data", void 0);
    __decorate([
        Prop()
    ], DataBox.prototype, "page", void 0);
    __decorate([
        Prop({ default: true })
    ], DataBox.prototype, "showPage", void 0);
    __decorate([
        Prop()
    ], DataBox.prototype, "sort", void 0);
    __decorate([
        Prop()
    ], DataBox.prototype, "selectionList", void 0);
    __decorate([
        Prop()
    ], DataBox.prototype, "selectionRow", void 0);
    __decorate([
        Prop({ default: 528 })
    ], DataBox.prototype, "maxHeight", void 0);
    __decorate([
        Prop()
    ], DataBox.prototype, "height", void 0);
    __decorate([
        Prop({ type: Boolean })
    ], DataBox.prototype, "hiddenIndex", void 0);
    __decorate([
        Prop({ type: Boolean })
    ], DataBox.prototype, "isSpan", void 0);
    __decorate([
        Prop({
            type: String,
            default: "序号"
        })
    ], DataBox.prototype, "indexLabel", void 0);
    __decorate([
        Prop({
            type: Function,
            default: function () { return ""; }
        })
    ], DataBox.prototype, "rowClassName", void 0);
    __decorate([
        Prop({
            default: true
        })
    ], DataBox.prototype, "stripe", void 0);
    __decorate([
        Prop({
            type: String
        })
    ], DataBox.prototype, "rowSpanKey", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], DataBox.prototype, "showCaseMark", void 0);
    __decorate([
        Prop({ type: Function })
    ], DataBox.prototype, "cellStyle", void 0);
    __decorate([
        Emit("onRowClick")
    ], DataBox.prototype, "onRowClick", null);
    __decorate([
        Emit("onPageChange")
    ], DataBox.prototype, "pageConfigChange", null);
    __decorate([
        Emit("update:selectionList")
    ], DataBox.prototype, "updateSelectionList", null);
    __decorate([
        Emit("update:selectionRow")
    ], DataBox.prototype, "updateSelectionRow", null);
    __decorate([
        Watch("selectionRow", { immediate: true })
    ], DataBox.prototype, "onSelectionRowChange", null);
    __decorate([
        Watch("selectionList", { immediate: true })
    ], DataBox.prototype, "onSelectionListChanged", null);
    __decorate([
        Watch("data")
    ], DataBox.prototype, "onDataChanged", null);
    DataBox = __decorate([
        Component({
            components: {}
        })
    ], DataBox);
    return DataBox;
}(Vue));
export default DataBox;
